import { render, staticRenderFns } from "./BsiCouponList.vue?vue&type=template&id=227cce79"
import script from "./BsiCouponList.vue?vue&type=script&lang=js"
export * from "./BsiCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports